/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkPattern } from './WorkPattern';
import {
    WorkPatternFromJSON,
    WorkPatternFromJSONTyped,
    WorkPatternToJSON,
    WorkPatternToJSONTyped,
} from './WorkPattern';

/**
 * 
 * @export
 * @interface UpdateWorkPatternResponse
 */
export interface UpdateWorkPatternResponse {
    /**
     * 
     * @type {WorkPattern}
     * @memberof UpdateWorkPatternResponse
     */
    data: WorkPattern;
}

/**
 * Check if a given object implements the UpdateWorkPatternResponse interface.
 */
export function instanceOfUpdateWorkPatternResponse(value: object): value is UpdateWorkPatternResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateWorkPatternResponseFromJSON(json: any): UpdateWorkPatternResponse {
    return UpdateWorkPatternResponseFromJSONTyped(json, false);
}

export function UpdateWorkPatternResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWorkPatternResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': WorkPatternFromJSON(json['data']),
    };
}

  export function UpdateWorkPatternResponseToJSON(json: any): UpdateWorkPatternResponse {
      return UpdateWorkPatternResponseToJSONTyped(json, false);
  }

  export function UpdateWorkPatternResponseToJSONTyped(value?: UpdateWorkPatternResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': WorkPatternToJSON(value['data']),
    };
}

